import React, { useState } from 'react';
import {
  Container,
  Box,
  Typography,
  Tab,
  Tabs,
  Paper,
  Divider
} from '@mui/material';

// Import all admin components
import AdminDashboard from './Dashboard';
import ManagePreferences from './ManagePreferences';
import ManageMeals from './ManageMeals';
import AdminNavigation from './AdminNavigation';

// TabPanel component for showing different tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
      style={{ flexGrow: 1 }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const AdminAccessPanel = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary" fontWeight="bold">
          Kya Banega Aaj - Admin Panel
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Manage all aspects of your Kya Banega Aaj application
        </Typography>
      </Paper>

      <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 180px)' }}>
        <Paper elevation={1}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="Dashboard" />
            <Tab label="Manage Preferences & Filters" />
            <Tab label="Manage Meal Ideas" />
            <Tab label="Admin Navigation" />
          </Tabs>
        </Paper>
        
        <TabPanel value={currentTab} index={0}>
          <AdminDashboard />
        </TabPanel>
        
        <TabPanel value={currentTab} index={1}>
          <ManagePreferences />
        </TabPanel>
        
        <TabPanel value={currentTab} index={2}>
          <ManageMeals />
        </TabPanel>
        
        <TabPanel value={currentTab} index={3}>
          <AdminNavigation />
        </TabPanel>
      </Box>
    </Container>
  );
};

export default AdminAccessPanel;
